import { baseApi as api } from "../baseApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getV2AdminBundleAssignments: build.query<
      GetV2AdminBundleAssignmentsApiResponse,
      GetV2AdminBundleAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments`,
        params: {
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          status: queryArg.status,
        },
      }),
    }),
    postV2AdminBundleAssignments: build.mutation<
      PostV2AdminBundleAssignmentsApiResponse,
      PostV2AdminBundleAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments`,
        method: "POST",
        body: queryArg.createAssignmentRequest,
      }),
    }),
    postV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundles:
      build.mutation<
        PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiResponse,
        PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/bundle-assignments/organizations/${queryArg.organizationId}/sync-bundles`,
          method: "POST",
        }),
      }),
    getV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesPreview:
      build.query<
        GetV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesPreviewApiResponse,
        GetV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesPreviewApiArg
      >({
        query: (queryArg) => ({
          url: `/v2/admin/bundle-assignments/organizations/${queryArg.organizationId}/sync-bundles/preview`,
        }),
      }),
    getV2AdminBundleAssignmentsByAssignmentId: build.query<
      GetV2AdminBundleAssignmentsByAssignmentIdApiResponse,
      GetV2AdminBundleAssignmentsByAssignmentIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}`,
      }),
    }),
    postV2AdminBundleAssignmentsByAssignmentIdCancel: build.mutation<
      PostV2AdminBundleAssignmentsByAssignmentIdCancelApiResponse,
      PostV2AdminBundleAssignmentsByAssignmentIdCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}/cancel`,
        method: "POST",
        body: queryArg.cancelBundleRequest,
      }),
    }),
    postV2AdminBundleAssignmentsByAssignmentIdReplace: build.mutation<
      PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiResponse,
      PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}/replace`,
        method: "POST",
        body: queryArg.replaceBundleRequest,
      }),
    }),
    putV2AdminBundleAssignmentsByAssignmentIdStatus: build.mutation<
      PutV2AdminBundleAssignmentsByAssignmentIdStatusApiResponse,
      PutV2AdminBundleAssignmentsByAssignmentIdStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundle-assignments/${queryArg.assignmentId}/status`,
        method: "PUT",
        body: queryArg.updateAssignmentStatusRequest,
      }),
    }),
    getV2AdminBundles: build.query<
      GetV2AdminBundlesApiResponse,
      GetV2AdminBundlesApiArg
    >({
      query: () => ({ url: `/v2/admin/bundles` }),
    }),
    getV2AdminBundlesByBundleId: build.query<
      GetV2AdminBundlesByBundleIdApiResponse,
      GetV2AdminBundlesByBundleIdApiArg
    >({
      query: (queryArg) => ({ url: `/v2/admin/bundles/${queryArg.bundleId}` }),
    }),
    getV2AdminBundlesByBundleIdAssignments: build.query<
      GetV2AdminBundlesByBundleIdAssignmentsApiResponse,
      GetV2AdminBundlesByBundleIdAssignmentsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/bundles/${queryArg.bundleId}/assignments`,
        params: {
          page: queryArg.page,
          per_page: queryArg.perPage,
          status: queryArg.status,
        },
      }),
    }),
    getV2AdminCapabilities: build.query<
      GetV2AdminCapabilitiesApiResponse,
      GetV2AdminCapabilitiesApiArg
    >({
      query: () => ({ url: `/v2/admin/capabilities` }),
    }),
    getV2AdminCapabilitiesByCapabilityId: build.query<
      GetV2AdminCapabilitiesByCapabilityIdApiResponse,
      GetV2AdminCapabilitiesByCapabilityIdApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/capabilities/${queryArg.capabilityId}`,
      }),
    }),
    getV2AdminEntitlements: build.query<
      GetV2AdminEntitlementsApiResponse,
      GetV2AdminEntitlementsApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/entitlements`,
        params: {
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
        },
      }),
    }),
    deleteV2AdminEntitlementsUsage: build.mutation<
      DeleteV2AdminEntitlementsUsageApiResponse,
      DeleteV2AdminEntitlementsUsageApiArg
    >({
      query: () => ({ url: `/v2/admin/entitlements/usage`, method: "DELETE" }),
    }),
    getV2AdminEntitlementsUsage: build.query<
      GetV2AdminEntitlementsUsageApiResponse,
      GetV2AdminEntitlementsUsageApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/entitlements/usage`,
        params: {
          organization_id: queryArg.organizationId,
          user_id: queryArg.userId,
          capability_id: queryArg.capabilityId,
          usage_period: queryArg.usagePeriod,
          page: queryArg.page,
          per_page: queryArg.perPage,
        },
      }),
    }),
    postV2AdminEntitlementsUsageEmit: build.mutation<
      PostV2AdminEntitlementsUsageEmitApiResponse,
      PostV2AdminEntitlementsUsageEmitApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/admin/entitlements/usage/emit`,
        method: "POST",
        body: queryArg.emitTestUsageRequest,
      }),
    }),
    getV2ProviderBundles: build.query<
      GetV2ProviderBundlesApiResponse,
      GetV2ProviderBundlesApiArg
    >({
      query: () => ({ url: `/v2/provider/bundles` }),
    }),
    getV2ProviderEntitlements: build.query<
      GetV2ProviderEntitlementsApiResponse,
      GetV2ProviderEntitlementsApiArg
    >({
      query: () => ({ url: `/v2/provider/entitlements` }),
    }),
    getV2ProviderSubscription: build.query<
      GetV2ProviderSubscriptionApiResponse,
      GetV2ProviderSubscriptionApiArg
    >({
      query: () => ({ url: `/v2/provider/subscription` }),
    }),
    getV2ProviderSubscriptionBillingInfo: build.query<
      GetV2ProviderSubscriptionBillingInfoApiResponse,
      GetV2ProviderSubscriptionBillingInfoApiArg
    >({
      query: () => ({ url: `/v2/provider/subscription/billing-info` }),
    }),
    putV2ProviderSubscriptionBillingInfo: build.mutation<
      PutV2ProviderSubscriptionBillingInfoApiResponse,
      PutV2ProviderSubscriptionBillingInfoApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/subscription/billing-info`,
        method: "PUT",
        body: queryArg.updateBillingDetailsRequest,
      }),
    }),
    getV2ProviderSubscriptionBillingInterval: build.query<
      GetV2ProviderSubscriptionBillingIntervalApiResponse,
      GetV2ProviderSubscriptionBillingIntervalApiArg
    >({
      query: () => ({ url: `/v2/provider/subscription/billing-interval` }),
    }),
    putV2ProviderSubscriptionBillingInterval: build.mutation<
      PutV2ProviderSubscriptionBillingIntervalApiResponse,
      PutV2ProviderSubscriptionBillingIntervalApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/subscription/billing-interval`,
        method: "PUT",
        body: queryArg.changeBillingIntervalRequest,
      }),
    }),
    getV2ProviderSubscriptionBundles: build.query<
      GetV2ProviderSubscriptionBundlesApiResponse,
      GetV2ProviderSubscriptionBundlesApiArg
    >({
      query: () => ({ url: `/v2/provider/subscription/bundles` }),
    }),
    postV2ProviderSubscriptionCancel: build.mutation<
      PostV2ProviderSubscriptionCancelApiResponse,
      PostV2ProviderSubscriptionCancelApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/subscription/cancel`,
        method: "POST",
        body: queryArg.cancelSubscriptionRequest,
      }),
    }),
    getFullSubscriptionDetails: build.query<
      GetFullSubscriptionDetailsApiResponse,
      GetFullSubscriptionDetailsApiArg
    >({
      query: () => ({ url: `/v2/provider/subscription/details` }),
    }),
    getV2ProviderSubscriptionInvoices: build.query<
      GetV2ProviderSubscriptionInvoicesApiResponse,
      GetV2ProviderSubscriptionInvoicesApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/subscription/invoices`,
        params: {
          limit: queryArg.limit,
          starting_after: queryArg.startingAfter,
        },
      }),
    }),
    getV2ProviderSubscriptionPaymentMethod: build.query<
      GetV2ProviderSubscriptionPaymentMethodApiResponse,
      GetV2ProviderSubscriptionPaymentMethodApiArg
    >({
      query: () => ({ url: `/v2/provider/subscription/payment-method` }),
    }),
    putV2ProviderSubscriptionPaymentMethod: build.mutation<
      PutV2ProviderSubscriptionPaymentMethodApiResponse,
      PutV2ProviderSubscriptionPaymentMethodApiArg
    >({
      query: (queryArg) => ({
        url: `/v2/provider/subscription/payment-method`,
        method: "PUT",
        body: queryArg.updatePaymentMethodRequest,
      }),
    }),
    postV2ProviderSubscriptionReactivate: build.mutation<
      PostV2ProviderSubscriptionReactivateApiResponse,
      PostV2ProviderSubscriptionReactivateApiArg
    >({
      query: () => ({
        url: `/v2/provider/subscription/reactivate`,
        method: "POST",
      }),
    }),
    postV2ProviderSubscriptionSetupIntent: build.mutation<
      PostV2ProviderSubscriptionSetupIntentApiResponse,
      PostV2ProviderSubscriptionSetupIntentApiArg
    >({
      query: () => ({
        url: `/v2/provider/subscription/setup-intent`,
        method: "POST",
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as enhancedApi };
export type GetV2AdminBundleAssignmentsApiResponse =
  /** status 200 OK */ BundleAssignmentListResponse;
export type GetV2AdminBundleAssignmentsApiArg = {
  /** Filter by organization (required) */
  organizationId?: string | null;
  /** Filter by user within organization (optional) */
  userId?: string | null;
  /** Filter by status */
  status?: string | null;
};
export type PostV2AdminBundleAssignmentsApiResponse =
  /** status 201 Created */ BundleAssignmentResponse2;
export type PostV2AdminBundleAssignmentsApiArg = {
  createAssignmentRequest: CreateAssignmentRequest;
};
export type PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiResponse =
  /** status 200 OK */ SyncBundlesResponse;
export type PostV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesApiArg =
  {
    organizationId: string;
  };
export type GetV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesPreviewApiResponse =
  /** status 200 OK */ SyncBundlesResponse;
export type GetV2AdminBundleAssignmentsOrganizationsByOrganizationIdSyncBundlesPreviewApiArg =
  {
    organizationId: string;
  };
export type GetV2AdminBundleAssignmentsByAssignmentIdApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type GetV2AdminBundleAssignmentsByAssignmentIdApiArg = {
  assignmentId: string;
};
export type PostV2AdminBundleAssignmentsByAssignmentIdCancelApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type PostV2AdminBundleAssignmentsByAssignmentIdCancelApiArg = {
  assignmentId: string;
  cancelBundleRequest: CancelBundleRequest;
};
export type PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type PostV2AdminBundleAssignmentsByAssignmentIdReplaceApiArg = {
  assignmentId: string;
  replaceBundleRequest: ReplaceBundleRequest;
};
export type PutV2AdminBundleAssignmentsByAssignmentIdStatusApiResponse =
  /** status 200 OK */ BundleAssignmentResponse2;
export type PutV2AdminBundleAssignmentsByAssignmentIdStatusApiArg = {
  assignmentId: string;
  updateAssignmentStatusRequest: UpdateAssignmentStatusRequest;
};
export type GetV2AdminBundlesApiResponse =
  /** status 200 OK */ BundleListResponse;
export type GetV2AdminBundlesApiArg = void;
export type GetV2AdminBundlesByBundleIdApiResponse =
  /** status 200 OK */ BundleResponse2;
export type GetV2AdminBundlesByBundleIdApiArg = {
  bundleId: string;
};
export type GetV2AdminBundlesByBundleIdAssignmentsApiResponse =
  /** status 200 OK */ ListResponseEnrichedBundleAssignmentResponse;
export type GetV2AdminBundlesByBundleIdAssignmentsApiArg = {
  bundleId: string;
  /** Page number (1-based) */
  page?: number;
  /** Items per page (max 1000) */
  perPage?: number;
  /** Filter by assignment status */
  status?: ("pending" | "active" | "canceled" | "expired") | null;
};
export type GetV2AdminCapabilitiesApiResponse =
  /** status 200 OK */ CapabilityListResponse;
export type GetV2AdminCapabilitiesApiArg = void;
export type GetV2AdminCapabilitiesByCapabilityIdApiResponse =
  /** status 200 OK */ CapabilityResponse2;
export type GetV2AdminCapabilitiesByCapabilityIdApiArg = {
  capabilityId: string;
};
export type GetV2AdminEntitlementsApiResponse =
  /** status 200 OK */ EntitlementListResponse;
export type GetV2AdminEntitlementsApiArg = {
  /** Organization ID (required) */
  organizationId?: string | null;
  /** User ID (required) */
  userId?: string | null;
};
export type DeleteV2AdminEntitlementsUsageApiResponse =
  /** status 200 OK */ DeleteTestUsageResponse;
export type DeleteV2AdminEntitlementsUsageApiArg = void;
export type GetV2AdminEntitlementsUsageApiResponse =
  /** status 200 OK */ UsageEventListResponse;
export type GetV2AdminEntitlementsUsageApiArg = {
  /** Organization ID (required) */
  organizationId?: string | null;
  /** User ID (required) */
  userId?: string | null;
  /** Capability ID (required) */
  capabilityId?: string | null;
  /** Usage period: daily, weekly, monthly (required) */
  usagePeriod?: string | null;
  /** Page number */
  page?: number;
  /** Items per page */
  perPage?: number;
};
export type PostV2AdminEntitlementsUsageEmitApiResponse =
  /** status 200 OK */ EmitTestUsageResponse;
export type PostV2AdminEntitlementsUsageEmitApiArg = {
  emitTestUsageRequest: EmitTestUsageRequest;
};
export type GetV2ProviderBundlesApiResponse =
  /** status 200 OK */ BundleCatalogResponse;
export type GetV2ProviderBundlesApiArg = void;
export type GetV2ProviderEntitlementsApiResponse =
  /** status 200 OK */ EntitlementListResponse;
export type GetV2ProviderEntitlementsApiArg = void;
export type GetV2ProviderSubscriptionApiResponse =
  /** status 200 OK */ SubscriptionStatusResponse;
export type GetV2ProviderSubscriptionApiArg = void;
export type GetV2ProviderSubscriptionBillingInfoApiResponse =
  /** status 200 OK */ BillingInfoResponse;
export type GetV2ProviderSubscriptionBillingInfoApiArg = void;
export type PutV2ProviderSubscriptionBillingInfoApiResponse =
  /** status 200 OK */ BillingDetailsResponse;
export type PutV2ProviderSubscriptionBillingInfoApiArg = {
  updateBillingDetailsRequest: UpdateBillingDetailsRequest;
};
export type GetV2ProviderSubscriptionBillingIntervalApiResponse =
  /** status 200 OK */ BillingIntervalResponse;
export type GetV2ProviderSubscriptionBillingIntervalApiArg = void;
export type PutV2ProviderSubscriptionBillingIntervalApiResponse =
  /** status 200 OK */ ChangeBillingIntervalResponse;
export type PutV2ProviderSubscriptionBillingIntervalApiArg = {
  changeBillingIntervalRequest: ChangeBillingIntervalRequest;
};
export type GetV2ProviderSubscriptionBundlesApiResponse =
  /** status 200 OK */ ActiveBundlesResponse;
export type GetV2ProviderSubscriptionBundlesApiArg = void;
export type PostV2ProviderSubscriptionCancelApiResponse =
  /** status 200 OK */ SubscriptionStateResponse;
export type PostV2ProviderSubscriptionCancelApiArg = {
  cancelSubscriptionRequest: CancelSubscriptionRequest;
};
export type GetFullSubscriptionDetailsApiResponse =
  /** status 200 OK */ FullSubscriptionDetailsResponse;
export type GetFullSubscriptionDetailsApiArg = void;
export type GetV2ProviderSubscriptionInvoicesApiResponse =
  /** status 200 OK */ SubscriptionInvoicesResponse;
export type GetV2ProviderSubscriptionInvoicesApiArg = {
  /** Number of invoices to return */
  limit?: number;
  /** Invoice ID to start after for pagination */
  startingAfter?: string | null;
};
export type GetV2ProviderSubscriptionPaymentMethodApiResponse =
  /** status 200 OK */ PaymentMethodResponse;
export type GetV2ProviderSubscriptionPaymentMethodApiArg = void;
export type PutV2ProviderSubscriptionPaymentMethodApiResponse =
  /** status 200 OK */ PaymentMethodResponse;
export type PutV2ProviderSubscriptionPaymentMethodApiArg = {
  updatePaymentMethodRequest: UpdatePaymentMethodRequest;
};
export type PostV2ProviderSubscriptionReactivateApiResponse =
  /** status 200 OK */ SubscriptionStateResponse;
export type PostV2ProviderSubscriptionReactivateApiArg = void;
export type PostV2ProviderSubscriptionSetupIntentApiResponse =
  /** status 200 OK */ SetupIntentResponse;
export type PostV2ProviderSubscriptionSetupIntentApiArg = void;
export type BundleAssignmentResponse = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Effective from timestamp */
  effective_from: string;
  /** Effective to timestamp */
  effective_to?: string | null;
  /** Organization UUID */
  organization_id?: string | null;
  /** Assignment source (stripe, manual, trial) */
  source: string;
  /** Status (pending, active, canceled, expired) */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
  /** User ID */
  user_id?: string | null;
};
export type BundleAssignmentListResponse = {
  /** List of assignments */
  assignments?: BundleAssignmentResponse[];
};
export type ClientErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the client error */
  status?: number;
};
export type ValidationErrorElement = {
  ctx?: object;
  loc: string[];
  msg: string;
  type: string;
};
export type ValidationError = ValidationErrorElement[];
export type ServerErrorResponse = {
  /** The error code for the error */
  error_code?: string;
  /** The message for the error */
  message?: string;
  /** The HTTP status code for the server error */
  status?: number;
};
export type BundleAssignmentResponse2 = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Effective from timestamp */
  effective_from: string;
  /** Effective to timestamp */
  effective_to?: string | null;
  /** Organization UUID */
  organization_id?: string | null;
  /** Assignment source (stripe, manual, trial) */
  source: string;
  /** Status (pending, active, canceled, expired) */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
  /** User ID */
  user_id?: string | null;
};
export type CreateAssignmentRequest = {
  /** Bundle UUID */
  bundle_id: string;
  /** When assignment becomes effective (manual/trial only) */
  effective_from?: string | null;
  /** When assignment ends (manual/trial only) */
  effective_to?: string | null;
  /** Organization UUID (required for stripe source) */
  organization_id?: string | null;
  /** Assignment source: 'manual' (no billing), 'trial' (no billing), or 'stripe' (adds to Stripe subscription) */
  source?: string;
  /** User ID */
  user_id?: string | null;
};
export type SyncChangeResponse = {
  /** Action taken: 'created', 'updated', 'removed' */
  action: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Additional details */
  details?: string | null;
  /** New quantity */
  new_quantity?: number | null;
  /** Previous quantity */
  old_quantity?: number | null;
  /** Stripe subscription item ID */
  stripe_item_id?: string | null;
};
export type SyncBundlesResponse = {
  /** List of changes made */
  changes?: SyncChangeResponse[];
  /** Error message if sync failed */
  error?: string | null;
  /** Whether sync completed successfully */
  success: boolean;
};
export type CancelBundleRequest = {
  /** If True, cancel immediately. If False (default), defer cancellation until the end of the billing cycle. */
  cancel_immediately?: boolean;
  /** Organization UUID */
  organization_id: string;
  /** Optional reason for cancellation (e.g., 'admin_cancel'). */
  reason?: string | null;
};
export type ReplaceBundleRequest = {
  /** Bundle ID to replace with */
  new_bundle_id: string;
  /** Organization UUID */
  organization_id: string;
  /** User ID (None for org-level assignments) */
  user_id?: string | null;
};
export type UpdateAssignmentStatusRequest = {
  /** When status change takes effect */
  effective_to?: string | null;
  /** New status (pending, active, canceled, expired) */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
};
export type GrantResponse = {
  /** Bundle UUID */
  bundle_id: string;
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Grant UUID */
  grant_id: string;
  /** Metering type (none, fully_metered) */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Last updated timestamp */
  updated_at: string;
  /** Usage period (daily, weekly, monthly) */
  usage_period?: string | null;
};
export type MarketingFeature = {
  /** Whether feature is included in bundle */
  included: boolean;
  /** Feature display text */
  name: string;
};
export type BundleResponse = {
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type: string;
  /** Addon bundle IDs compatible with this tier (only for tier bundles) */
  compatible_addon_ids?: string[] | null;
  /** Created timestamp */
  created_at: string;
  /** Bundle description */
  description?: string | null;
  /** Grants in this bundle */
  grants?: GrantResponse[];
  /** Whether bundle is hidden from listings */
  hidden: boolean;
  /** Marketing features for pricing page display */
  marketing_features?: MarketingFeature[];
  /** Bundle name */
  name: string;
  /** Stripe product ID (None for virtual bundles) */
  stripe_product_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
};
export type BundleListResponse = {
  /** List of bundles */
  bundles?: BundleResponse[];
};
export type GrantResponse2 = {
  /** Bundle UUID */
  bundle_id: string;
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Grant UUID */
  grant_id: string;
  /** Metering type (none, fully_metered) */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Last updated timestamp */
  updated_at: string;
  /** Usage period (daily, weekly, monthly) */
  usage_period?: string | null;
};
export type MarketingFeature2 = {
  /** Whether feature is included in bundle */
  included: boolean;
  /** Feature display text */
  name: string;
};
export type BundleResponse2 = {
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type: string;
  /** Addon bundle IDs compatible with this tier (only for tier bundles) */
  compatible_addon_ids?: string[] | null;
  /** Created timestamp */
  created_at: string;
  /** Bundle description */
  description?: string | null;
  /** Grants in this bundle */
  grants?: GrantResponse2[];
  /** Whether bundle is hidden from listings */
  hidden: boolean;
  /** Marketing features for pricing page display */
  marketing_features?: MarketingFeature2[];
  /** Bundle name */
  name: string;
  /** Stripe product ID (None for virtual bundles) */
  stripe_product_id?: string | null;
  /** Last updated timestamp */
  updated_at: string;
};
export type EnrichedBundleAssignmentResponse = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Created timestamp */
  created_at: string;
  /** Effective from timestamp */
  effective_from: string;
  /** Effective to timestamp */
  effective_to?: string | null;
  /** Organization UUID */
  organization_id: string;
  /** Organization name */
  organization_name?: string | null;
  /** Assignment source (stripe, manual, trial) */
  source: string;
  /** Status (pending, active, canceled, expired) */
  status: string;
  /** Last updated timestamp */
  updated_at: string;
  /** User ID (null for org-level assignments) */
  user_id?: string | null;
  /** User name (null for org-level assignments) */
  user_name?: string | null;
};
export type ListResponseEnrichedBundleAssignmentResponse = {
  items: EnrichedBundleAssignmentResponse[];
  page?: number;
  per_page?: number;
  total?: number;
  total_pages?: number;
};
export type CapabilityResponse = {
  /** Capability UUID */
  capability_id: string;
  /** Created timestamp */
  created_at: string;
  /** Capability description */
  description?: string | null;
  /** Unique capability name */
  name: string;
  /** Last updated timestamp */
  updated_at: string;
};
export type CapabilityListResponse = {
  /** List of capabilities */
  capabilities?: CapabilityResponse[];
};
export type CapabilityResponse2 = {
  /** Capability UUID */
  capability_id: string;
  /** Created timestamp */
  created_at: string;
  /** Capability description */
  description?: string | null;
  /** Unique capability name */
  name: string;
  /** Last updated timestamp */
  updated_at: string;
};
export type EntitlementResponse = {
  /** Source of the assignment (stripe, manual, trial) */
  assignment_source: string;
  /** Bundle UUID that granted this entitlement */
  bundle_id: string;
  /** Name of the bundle */
  bundle_name: string;
  /** Description of the capability */
  capability_description?: string | null;
  /** Human-friendly display name for the capability */
  capability_display_name?: string | null;
  /** Capability UUID */
  capability_id: string;
  /** Name of the capability */
  capability_name: string;
  /** End of current usage period */
  current_period_end?: string | null;
  /** Start of current usage period */
  current_period_start?: string | null;
  /** Usage count in current period (null if not tracked) */
  current_usage?: number | null;
  /** Metering type (none, fully_metered, hybrid) */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Remaining quota (null if unlimited) */
  quota_remaining?: number | null;
  /** Period for quota reset (daily, weekly, monthly) */
  usage_period?: string | null;
};
export type EntitlementListResponse = {
  /** List of entitlements */
  entitlements?: EntitlementResponse[];
};
export type DeleteTestUsageResponse = {
  /** Number of events deleted */
  events_deleted: number;
};
export type UsageEventResponse = {
  /** Capability UUID */
  capability_id: string;
  /** When the usage occurred */
  created_at: string;
  /** Usage event UUID */
  event_id: string;
  /** Additional context */
  metadata?: {
    [key: string]: any;
  } | null;
  /** Original event ID that triggered this usage */
  source_event_id?: string | null;
  /** Event type that triggered this usage */
  source_event_type?: string | null;
};
export type UsageEventListResponse = {
  /** List of usage events */
  items?: UsageEventResponse[];
  /** Current page number */
  page: number;
  /** Items per page */
  per_page: number;
  /** Total number of events */
  total: number;
  /** Total number of pages */
  total_pages: number;
};
export type EmitTestUsageResponse = {
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name: string;
  /** Number of events created */
  events_created: number;
};
export type EmitTestUsageRequest = {
  /** Name of the capability (e.g., 'note_creation') */
  capability_name: string;
  /** Number of usage events to emit */
  count?: number;
  /** Organization UUID */
  organization_id: string;
  /** Provider/user ID */
  user_id: string;
};
export type CapabilityGrantResponse = {
  /** Capability UUID */
  capability_id: string;
  /** Capability name */
  capability_name?: string | null;
  /** Metering type: 'none', 'fully_metered', or 'hybrid' */
  metering_type: string;
  /** Usage quota (null = unlimited) */
  quota?: number | null;
  /** Usage period: 'daily', 'weekly', or 'monthly' */
  usage_period?: string | null;
};
export type IntroOfferResponse = {
  /** Fixed amount discount in cents */
  amount_off?: number | null;
  /** Percentage discount (1-100) */
  percent_off?: number | null;
};
export type MarketingFeatureResponse = {
  /** Whether feature is included in bundle */
  included: boolean;
  /** Feature display text */
  name: string;
};
export type BundlePriceResponse = {
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type: string;
  /** IDs of add-ons compatible with this tier bundle (tier bundles only) */
  compatible_addon_ids?: string[] | null;
  /** Currency code (e.g., 'usd') */
  currency?: string | null;
  /** Bundle description */
  description?: string | null;
  /** Capabilities granted by this bundle with quota and metering details */
  grants?: CapabilityGrantResponse[];
  /** Introductory offer if available */
  intro_offer?: IntroOfferResponse | null;
  /** Marketing features for pricing page display */
  marketing_features?: MarketingFeatureResponse[];
  /** Stripe monthly price ID */
  monthly_price_id?: string | null;
  /** Monthly price in cents (e.g., 2900 = $29.00) */
  monthly_unit_amount?: number | null;
  /** Bundle name */
  name: string;
  /** Whether the bundle can be purchased (False for hidden bundles) */
  purchasable?: boolean;
  /** Stripe product ID */
  stripe_product_id: string;
  /** Stripe yearly price ID */
  yearly_price_id?: string | null;
  /** Yearly price in cents (e.g., 29000 = $290.00) */
  yearly_unit_amount?: number | null;
};
export type BundleCatalogResponse = {
  /** Available bundles with pricing */
  bundles?: BundlePriceResponse[];
};
export type SubscriptionStatusResponse = {
  /** Current billing period end */
  current_period_end?: string | null;
  /** Whether customer has a payment method on file */
  has_payment_method?: boolean;
  /** Whether organization has a subscription */
  has_subscription: boolean;
  /** Stripe customer ID */
  stripe_customer_id?: string | null;
  /** Stripe subscription ID */
  stripe_subscription_id?: string | null;
  /** Stripe subscription status */
  subscription_status?: string | null;
};
export type BillingAddress = {
  /** City */
  city?: string | null;
  /** Two-letter country code (e.g., 'US') */
  country?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 */
  line2?: string | null;
  /** Postal/ZIP code */
  postal_code?: string | null;
  /** State/province/region */
  state?: string | null;
};
export type BillingDetails = {
  /** Billing address */
  address?: BillingAddress | null;
  /** Customer email */
  email?: string | null;
  /** Customer name */
  name?: string | null;
  /** Customer phone number */
  phone?: string | null;
};
export type CardDetails = {
  /** Card brand (e.g., 'visa', 'mastercard') */
  brand: string;
  /** Expiration month (1-12) */
  exp_month: number;
  /** Expiration year (e.g., 2025) */
  exp_year: number;
  /** Last 4 digits of card */
  last4: string;
};
export type PendingVerification = {
  /** When verification was initiated */
  created: string;
  /** Payment method type (us_bank_account) */
  payment_method_type: string;
  /** Stripe SetupIntent ID */
  setup_intent_id: string;
};
export type BankAccountDetails = {
  /** Account type (e.g., 'checking', 'savings') */
  account_type?: string | null;
  /** Name of the bank */
  bank_name?: string | null;
  /** Last 4 digits of account number */
  last4: string;
};
export type PaymentMethodInfo = {
  /** Card details if type is card */
  card?: CardDetails | null;
  /** Whether customer has a payment method on file */
  has_payment_method: boolean;
  /** Payment method ID */
  id?: string | null;
  /** Pending micro-deposit verification if in progress */
  pending_verification?: PendingVerification | null;
  /** Payment method type (e.g., 'card', 'us_bank_account') */
  type?: string | null;
  /** Bank account details if type is us_bank_account */
  us_bank_account?: BankAccountDetails | null;
};
export type BillingInfoResponse = {
  /** Customer billing details */
  billing_details: BillingDetails;
  /** Payment method information */
  payment_method: PaymentMethodInfo;
};
export type BillingAddress2 = {
  /** City */
  city?: string | null;
  /** Two-letter country code (e.g., 'US') */
  country?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 */
  line2?: string | null;
  /** Postal/ZIP code */
  postal_code?: string | null;
  /** State/province/region */
  state?: string | null;
};
export type BillingDetails2 = {
  /** Billing address */
  address?: BillingAddress2 | null;
  /** Customer email */
  email?: string | null;
  /** Customer name */
  name?: string | null;
  /** Customer phone number */
  phone?: string | null;
};
export type BillingDetailsResponse = {
  /** Updated billing details */
  billing_details: BillingDetails2;
};
export type BillingAddress3 = {
  /** City */
  city?: string | null;
  /** Two-letter country code (e.g., 'US') */
  country?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 */
  line2?: string | null;
  /** Postal/ZIP code */
  postal_code?: string | null;
  /** State/province/region */
  state?: string | null;
};
export type UpdateBillingDetailsRequest = {
  /** Billing address */
  address?: BillingAddress3 | null;
  /** Customer email */
  email?: string | null;
  /** Customer name */
  name?: string | null;
  /** Customer phone number */
  phone?: string | null;
};
export type BillingIntervalResponse = {
  /** Current billing interval: 'month' or 'year' */
  billing_interval: string;
};
export type ChangeBillingIntervalResponse = {
  /** New billing interval after change */
  billing_interval: string;
  /** Number of items skipped (no price for new interval) */
  items_skipped?: number;
  /** Number of subscription items migrated */
  items_updated?: number;
  /** Result message */
  message: string;
  /** Whether the change succeeded */
  success: boolean;
};
export type ChangeBillingIntervalRequest = {
  /** New billing interval: 'month' or 'year' */
  billing_interval: string;
};
export type IntroOfferResponse2 = {
  /** Fixed amount discount in cents */
  amount_off?: number | null;
  /** Percentage discount (1-100) */
  percent_off?: number | null;
};
export type ActiveBundleResponse = {
  /** Assignment UUID */
  assignment_id: string;
  /** Bundle description */
  bundle_description: string;
  /** Bundle UUID */
  bundle_id: string;
  /** Bundle name */
  bundle_name: string;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type: string;
  /** When bundle became active */
  effective_from: string;
  /** When bundle ends (if scheduled for cancellation) */
  effective_to?: string | null;
  /** Intro offer applied to this assignment */
  intro_offer?: IntroOfferResponse2 | null;
  /** Assignment source: 'stripe', 'manual', or 'trial' */
  source: string;
  /** Assignment status */
  status: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id?: string | null;
};
export type ActiveBundlesResponse = {
  /** Active bundle assignments */
  bundles?: ActiveBundleResponse[];
};
export type SubscriptionStateResponse = {
  /** Whether subscription will cancel at period end */
  cancel_at_period_end: boolean;
  /** When current billing period ends */
  current_period_end?: string | null;
  /** Subscription status (active, canceled, etc.) */
  status: string;
};
export type CancelSubscriptionRequest = {
  /** Optional reason for cancellation */
  cancellation_reason?: string | null;
};
export type BillingAddress4 = {
  /** City */
  city?: string | null;
  /** Two-letter country code (e.g., 'US') */
  country?: string | null;
  /** Street address line 1 */
  line1?: string | null;
  /** Street address line 2 */
  line2?: string | null;
  /** Postal/ZIP code */
  postal_code?: string | null;
  /** State/province/region */
  state?: string | null;
};
export type BillingDetails3 = {
  /** Billing address */
  address?: BillingAddress4 | null;
  /** Customer email */
  email?: string | null;
  /** Customer name */
  name?: string | null;
  /** Customer phone number */
  phone?: string | null;
};
export type DiscountInfo = {
  /** Fixed amount discount in cents */
  amount_off?: number | null;
  /** Display name of the coupon */
  coupon_name?: string | null;
  /** Currency for amount_off */
  currency?: string | null;
  /** 'once', 'repeating', or 'forever' */
  duration?: string | null;
  /** Months remaining if duration is 'repeating' */
  duration_in_months?: number | null;
  /** Percentage discount */
  percent_off?: number | null;
};
export type SubscriptionLineItem = {
  /** Associated bundle UUID */
  bundle_id?: string | null;
  /** Bundle name */
  bundle_name?: string | null;
  /** Bundle type: 'tier', 'add_on', or 'data_security' */
  bundle_type?: string | null;
  /** Currency code (e.g., 'usd') */
  currency: string;
  /** Item quantity */
  quantity: number;
  /** Stripe price ID */
  stripe_price_id: string;
  /** Stripe subscription item ID */
  stripe_subscription_item_id: string;
  /** Price in cents */
  unit_amount: number;
};
export type CardDetails2 = {
  /** Card brand (e.g., 'visa', 'mastercard') */
  brand: string;
  /** Expiration month (1-12) */
  exp_month: number;
  /** Expiration year (e.g., 2025) */
  exp_year: number;
  /** Last 4 digits of card */
  last4: string;
};
export type PendingVerification2 = {
  /** When verification was initiated */
  created: string;
  /** Payment method type (us_bank_account) */
  payment_method_type: string;
  /** Stripe SetupIntent ID */
  setup_intent_id: string;
};
export type BankAccountDetails2 = {
  /** Account type (e.g., 'checking', 'savings') */
  account_type?: string | null;
  /** Name of the bank */
  bank_name?: string | null;
  /** Last 4 digits of account number */
  last4: string;
};
export type PaymentMethodInfo2 = {
  /** Card details if type is card */
  card?: CardDetails2 | null;
  /** Whether customer has a payment method on file */
  has_payment_method: boolean;
  /** Payment method ID */
  id?: string | null;
  /** Pending micro-deposit verification if in progress */
  pending_verification?: PendingVerification2 | null;
  /** Payment method type (e.g., 'card', 'us_bank_account') */
  type?: string | null;
  /** Bank account details if type is us_bank_account */
  us_bank_account?: BankAccountDetails2 | null;
};
export type FullSubscriptionDetailsResponse = {
  /** Customer billing details (name, email, phone, address) */
  billing_details?: BillingDetails3 | null;
  /** Billing interval: 'month' or 'year' */
  billing_interval: string;
  /** Whether subscription will cancel at period end */
  cancel_at_period_end: boolean;
  /** Current billing period end */
  current_period_end: string;
  /** Current billing period start */
  current_period_start: string;
  /** Active discount/coupon applied to the subscription */
  discount?: DiscountInfo | null;
  /** Whether subscription is in trial */
  is_trialing: boolean;
  /** Subscription line items with bundle details */
  line_items: SubscriptionLineItem[];
  /** Payment method details (if exists) */
  payment_method?: PaymentMethodInfo2 | null;
  /** Stripe subscription status (active, trialing, past_due, etc.) */
  subscription_status: string;
  /** Days remaining in trial (if trialing) */
  trial_days_remaining?: number | null;
  /** Trial end date (if trialing) */
  trial_end?: string | null;
};
export type SubscriptionInvoice = {
  /** Amount due in cents */
  amount_due: number;
  /** Amount paid in cents */
  amount_paid: number;
  /** Amount remaining to be paid in cents */
  amount_remaining?: number;
  /** When the invoice was created */
  created: string;
  /** Due date if applicable */
  due_date?: string | null;
  /** URL to view invoice online */
  hosted_invoice_url?: string | null;
  /** Stripe invoice ID */
  id: string;
  /** URL to download invoice PDF */
  invoice_pdf?: string | null;
  /** Invoice number */
  number?: string | null;
  /** When the invoice was paid */
  paid_at?: string | null;
  /** Credit notes amount applied after payment in cents */
  post_payment_credit_notes_amount?: number;
  /** Credit notes amount applied before payment in cents */
  pre_payment_credit_notes_amount?: number;
  /** Invoice status (draft, open, paid, etc.) */
  status: string;
  /** Sum of all line items before discounts and taxes in cents */
  subtotal?: number;
  /** Total after discounts and taxes in cents (negative for credits) */
  total?: number;
};
export type SubscriptionInvoicesResponse = {
  /** Whether more invoices are available */
  has_more: boolean;
  /** List of invoices */
  invoices?: SubscriptionInvoice[];
  /** Use as starting_after for next page */
  next_cursor?: string | null;
};
export type CardDetails3 = {
  /** Card brand (e.g., 'visa', 'mastercard') */
  brand: string;
  /** Expiration month (1-12) */
  exp_month: number;
  /** Expiration year (e.g., 2025) */
  exp_year: number;
  /** Last 4 digits of card */
  last4: string;
};
export type BankAccountDetails3 = {
  /** Account type (e.g., 'checking', 'savings') */
  account_type?: string | null;
  /** Name of the bank */
  bank_name?: string | null;
  /** Last 4 digits of account number */
  last4: string;
};
export type PaymentMethodDetails = {
  /** Card details if type is card */
  card?: CardDetails3 | null;
  /** Payment method ID */
  id: string;
  /** Payment method type (e.g., 'card', 'us_bank_account') */
  type: string;
  /** Bank account details if type is us_bank_account */
  us_bank_account?: BankAccountDetails3 | null;
};
export type PendingVerification3 = {
  /** When verification was initiated */
  created: string;
  /** Payment method type (us_bank_account) */
  payment_method_type: string;
  /** Stripe SetupIntent ID */
  setup_intent_id: string;
};
export type PaymentMethodResponse = {
  /** Whether customer has a payment method on file */
  has_payment_method: boolean;
  /** Payment method details if available */
  payment_method?: PaymentMethodDetails | null;
  /** Pending micro-deposit verification if in progress */
  pending_verification?: PendingVerification3 | null;
};
export type UpdatePaymentMethodRequest = {
  /** Stripe PaymentMethod ID from Stripe Elements */
  payment_method_id: string;
};
export type SetupIntentResponse = {
  /** Client secret for Stripe Elements on frontend */
  client_secret: string;
  /** Stripe SetupIntent ID */
  setup_intent_id: string;
};
